import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcb85948"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn__text" }
const _hoisted_2 = { class: "btn__icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['btn', 'btn__toggler', { '--active': $data.isOpened }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.changeState && $options.changeState(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($data.isOpened ? "Hide " + $props.togglerText : "Show " + $props.togglerText), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Icon, { name: "Arrow" })
    ])
  ], 2))
}